import React from "react";
import {
  useAlertWithButtonActionsContext,
  useAlertWithButtonContext,
} from "../../Context/AlertMessageContext";
import { useLanguageContext } from "../../Context/LanguageContext";
export default function AlertWithButton(props) {
  const { handler } = props;
  const showAlertWithButton = useAlertWithButtonContext();
  const setAlertWithButton = useAlertWithButtonActionsContext();
  const { localization } = useLanguageContext();

  return (
    <div>
      {/* <button onClick={handleOpenModal}>Open Modal</button> */}
      {showAlertWithButton && (
        <div
          className="modal in dialogBox "
          id="MsgModalCenter"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="MsgModalCenterTitle"
          aria-hidden="true"
        >
          <div
            className="modal-dialog d-flex justify-content-center"
            role="document"
          >
            <div className="modal-content ">
              <div className="modal-header">
                <div className="container">
                  <div className="row">
                    <div className="col-10  pl-0 align-text-center ">
                      {localization.confirmation}
                    </div>
                  </div>
                </div>
              </div>

              <div className="modal-body ">{handler.message}</div>
              <div className="modal-footer">
                <div className="form-group marProp">
                  <div className="row">
                    <div className="col pl-0">
                      <button
                        type="button"
                        className="btn btn-primary mb-4 "
                        onClick={handler._func}
                      >
                        {localization.ok}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        // <div className="modal">
        //   <div className="modal-content">
        //     <div className="modal-header"></div>
        //     <p>{message}</p>
        //   </div>
        //   <div className="modal-footer">
        //     <div className="form-group marProp ">
        //       <button
        //         type="button"
        //         onClick={handleClose}
        //         className="btn btn-primary btn-block mb-4"
        //       >
        //         Ok
        //       </button>
        //     </div>
        //   </div>
        // </div>
      )}
    </div>
  );
}
